var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1667 4.85714C10.8344 4.85714 9.75439 5.92313 9.75439 7.2381C9.75439 8.55306 10.8344 9.61905 12.1667 9.61905C13.4989 9.61905 14.5789 8.55306 14.5789 7.2381C14.5789 5.92313 13.4989 4.85714 12.1667 4.85714ZM6.85965 7.2381C6.85965 4.34518 9.23568 2 12.1667 2C15.0977 2 17.4737 4.34518 17.4737 7.2381C17.4737 10.131 15.0977 12.4762 12.1667 12.4762C9.23568 12.4762 6.85965 10.131 6.85965 7.2381ZM4.55439 14.9628C5.54965 13.9804 6.89951 13.4286 8.30702 13.4286H16.0263C17.4338 13.4286 18.7837 13.9804 19.7789 14.9628C20.7742 15.9451 21.3333 17.2774 21.3333 18.6667V20.5714C21.3333 21.3604 20.6853 22 19.886 22C19.0866 22 18.4386 21.3604 18.4386 20.5714V18.6667C18.4386 18.0352 18.1844 17.4296 17.7321 16.9831C17.2797 16.5366 16.6661 16.2857 16.0263 16.2857H8.30702C7.66724 16.2857 7.05367 16.5366 6.60128 16.9831C6.14889 17.4296 5.89474 18.0352 5.89474 18.6667V20.5714C5.89474 21.3604 5.24673 22 4.44737 22C3.64801 22 3 21.3604 3 20.5714V18.6667C3 17.2774 3.55913 15.9451 4.55439 14.9628Z",
    fill: "#c02fb1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d6c37c43aa632bec2d6b21a252ad23a1.svg";
export { ForwardRef as ReactComponent };